export default {
  textStyle: {
    fontFamily: '"Joti One", cursive',
    fontSize: 120,
    fill: '#cbca62',
  },
};



// WEBPACK FOOTER //
// ./src/components/Title/styles.js